import { Integration_Service_Names_Enum } from '@main/graphql/types.admin.generated';

import { IntegrationService } from '../../../../lib';
import { MicrosoftEntraConnector } from '../../connector';

export const EntraIdService = IntegrationService.make({
  connector: MicrosoftEntraConnector,
  name: Integration_Service_Names_Enum.EntraId,
});
